import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { PersonStaff } from "./PersonStaff";
import type { ProfilePersonBase } from "./ProfilePersonBase";
import type { SignoutCrewDTOBase } from "./SignoutCrewDTOBase";
import type { SignoutStaff } from "./SignoutStaff";
import type { TrackedBase } from "./TrackedBase";

export class SignoutCrewStaff implements SignoutCrewDTOBase, TrackedBase, ProfilePersonBase {
  constructor(public readonly crewId: number, public readonly personId: PersonStaff | null, public readonly signoutId: SignoutStaff | null, public readonly cardNum: string | null, public readonly startActive: Date | null, public readonly endActive: Date | null, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly personName: string | null, public readonly personIdValue: number | null) {
    this.cbiServiceContext = null;
    this.signoutIdLoaded = this.signoutId != null;
    this.signoutIdCached = this.signoutId;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private signoutIdLoaded: boolean;
  private signoutIdCached: SignoutStaff | null;
  async signoutIdLazy(): Promise<SignoutStaff | null> {
    if (!this.signoutIdLoaded) {
      this.signoutIdCached = await this.cbiServiceContext!.personService().getSignoutCrewStaffSignoutId(this.crewId);
      this.signoutIdLoaded = true;
    }
    return this.signoutIdCached;
  }
}
